export enum EDatePattern {
  MONTH_YEAR = 'MM.yyyy',
  DATE = 'dd.MM.yyyy',
  DATE_TIME_WITHOUT_SECONDS = 'dd.MM.yyyy HH:mm',
  DATE_TIME = 'dd.MM.yyyy HH:mm:ss',
  YEAR_MONTH_DAY = 'yyyy-MM-dd',
  DD_MM_YYYY = 'dd-MM-yyyy',
  DATE_TIME_ISO_MARKED_TIMEZONE = `yyyy-MM-dd'T'HH:mm:ss`,
  YYYY_MM_DD = 'yyyy/MM/dd',
  MMMM_YYYY = 'MMMM YYYY',
  DATE_TIME_ISO_PATTERN = 'yyyy-MM-ddTHH:mm:ss',
  DATE_TIME_FOR_TRACKER = 'YYYY-MM-DD HH:mm:ss',
  DATE_TIME_FOR_TRACKER_NOT_SIMPLE = 'yyyy-MM-dd HH:mm:ss',
  TUI_YMD = 'YMD',
}
